import React, { Fragment, useState, useEffect } from "react";
import makeStyles from "@mui/styles/makeStyles";
import { map, sort } from "ramda";
import { notBlank } from "../../util/ext";
import { capitalize } from "../../util/stringFormat";

import Button from "@mui/material/Button";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";

import ListSummaryCard from "./ListSummaryCard";

const useStyles = makeStyles(theme => ({
  popoverPaper: {
    borderRadius: 5,
    padding: 12,
    margin: "0",
    boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.15)",
  },

  popoverText: {
    fontStyle: "italic",
    fontWeight: 600,
    fontSize: "1.6rem",
  },

  origin: {
    paddingLeft: 15,
  },

  card: {
    cursor: "pointer",
    width: "auto",
    minWidth: "auto",
    fontSize: "1.6rem",
  },
}));

const CSPCard = props => {
  const { content } = props;
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = event => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    navigator.clipboard.writeText(content.stipProperties[0].projectId).then(
      () => console.log("CSP project id copied"),
      () => alert("Sorry, ID could not be copied"),
    );
  };
  const closePopover = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? `${content.id}-ID-popover` : undefined;

  return (
    <Fragment>
      <Button
        color="primary"
        onClick={handleClick}
        className={classes.card}
        style={{ marginLeft: 10 }}
      >
        CSP
      </Button>
      <Popover
        id={id}
        classes={{ root: classes.popoverText, paper: classes.popoverPaper }}
        open={open}
        anchorEl={anchorEl}
        onClose={closePopover}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <div style={{ marginBottom: 7.5 }}>CSP Project ID Copied</div>
        <div>{content.stipProperties[0].projectId}</div>
      </Popover>
    </Fragment>
  );
};

const sortBySourceFilter = (sourceFilter, stipProperties) =>
  sort((a, b) => {
    return a.projectKey === sourceFilter.projectKey ? -1 : 1;
  }, stipProperties);

const StipCard = ({ stipProperties, sourceFilter }) => {
  const [data, setData] = useState([]);
  useEffect(() => {
    // If source parameter is present, order by those projects first
    const data = notBlank(sourceFilter)
      ? sortBySourceFilter(sourceFilter, stipProperties)
      : stipProperties;

    setData(
      map(
        property => ({
          id: Math.random(),
          name: capitalize(property.projectName),
        }),
        data,
      ),
    );
  }, [sourceFilter, stipProperties]);

  return <ListSummaryCard data={data} />;
};

const ContentOriginCard = props => {
  const { content, sourceFilter } = props;
  const classes = useStyles();

  return content.ripProperties && content.ripProperties.length !== 0 ? (
    <Typography className={classes.origin}>RIP</Typography>
  ) : content.stipProperties && content.stipProperties.length !== 0 ? (
    content.stipProperties[0].projectName ? (
      <StipCard
        sourceFilter={sourceFilter}
        stipProperties={content.stipProperties}
      />
    ) : (
      <CSPCard content={content} />
    )
  ) : content.sources && content.sources.length !== 0 ? (
    <StipCard stipProperties={content.sources} />
  ) : (
    <Typography className={classes.origin}>Upload</Typography>
  );
};

export default ContentOriginCard;
